import styled, { css } from 'styled-components';

import {
    spaceMixin,
    token,
} from '@zillow/constellation';
import { Row } from '@zillow/zrs-comet';

export const StyledRow = styled(Row)(({ isHeader, isCollapsed }) => css`
    ${isHeader && css`
        cursor: pointer;
        background-color: ${token('colors.coolGray100')};
    `}

    ${isHeader && !isCollapsed && css`
        border-radius: 4px 4px 0px 0px;
    `}

    ${!isHeader && !isCollapsed && css`
        border-radius: 0px 0px 4px 4px;
        && {
            border-top: 0px;
        }
    `}

    width: 620px;
    border: 1px solid ${token('colors.gray300')};
    padding-top: ${spaceMixin('sm')};
    padding-bottom: ${spaceMixin('sm')};
`);
